<template>
  <page :title="$tc('magazines.magazines')" size="is-xlarge">
    <div slot="page-header-right">
      <router-link to="magazines/create">
        <button class="button is-primary">
          <b-icon icon="plus"></b-icon>
          <span>
            <slot>{{$tc('magazines.add')}}</slot>
          </span>
        </button>
      </router-link>
    </div>

    <div class="box">
      <filters @input="(filters) => magazines.filter(filters).load()"></filters>

      <hr />

      <div class="card-content is-paddingless">
        <b-table
          :data="magazines.data"
          :loading="magazines.loading"
          paginated
          backend-pagination
          pagination-position="bottom"
          :current-page="magazines.current_page"
          :per-page="magazines.per_page"
          :total="magazines.total"
          @page-change="(page) => magazines.changePage(page)"
          backend-sorting
          @sort="(field, direction) => magazines.sort(field, direction)"
          :default-sort="['id', 'desc']"
          class="is-middle"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="Id" sortable width="60">{{
              props.row.id
            }}</b-table-column>

            <b-table-column field="cover" :label="$tc('logo')" width="60">
              <img :src="props.row.logo_url" width="50" />
            </b-table-column>

            <b-table-column field="name" :label="$tc('name')" sortable>
              <router-link
                :to="'magazines/' + props.row.id + '/edit'"
                class="has-text-dark"
                size="is-large"
                >{{ props.row.name }}</router-link
              >
            </b-table-column>

            <b-table-column field="publisher_id" :label="$tc('publisher._name')" sortable>
              <router-link
                v-if="props.row.publisher"
                :to="`/publishers/${props.row.publisher.id}`"
                class="has-text-grey is-block"
                >{{ props.row.publisher.name }}</router-link
              >
            </b-table-column>

            <b-table-column
              field="issues_count"
              :label="$tc('issue')"
              sortable
              centered
              width="150"
            >
              <router-link
                :to="'magazines/' + props.row.id + '/edit'"
                class="has-text-grey"
                size="is-large"
                >{{ props.row.issues_count }}</router-link
              >
            </b-table-column>

            <b-table-column
              field="latest_release_date"
              :label="$tc('dater.latest')"
              width="150"
              sortable
              centered
            >
              <div class="has-text-grey" v-if="props.row.latest_issue">
                <b-tooltip :label="props.row.latest_issue.release_date">
                  <router-link
                    :to="`magazines/${props.row.id}/edit`"
                    class="has-text-dark"
                    >{{
                      props.row.latest_issue.release_date | date
                    }}</router-link
                  >
                </b-tooltip>
              </div>
            </b-table-column>

            <b-table-column
              field="updated_at"
              sortable
              :label="$tc('dater.updated')"
              centered
              width="150"
            >
              <span class="has-text-grey">
                <b-tooltip :label="props.row.updated_at">{{
                  props.row.updated_at | fromNow
                }}</b-tooltip>
              </span>
            </b-table-column>

            <b-table-column field="edit">
              <div class="is-pulled-right">
                <links-dropdown
                  class="mr-2"
                  :links="[
                    {
                      label: 'Deep Link to listing issues',
                      url:
                        `${dl}://q?type=listing&key=magazine-${props.row.id}&title=` +
                        encodeURI(props.row.name),
                    },
                  ]"
                ></links-dropdown>

                <router-link
                  :to="'magazines/' + props.row.id + '/edit'"
                  class="button"
                  size="is-large"
                  >{{ $tc('edit') }}</router-link
                >
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>{{$tc('Nothinghere')}}</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
import Filters from "./Filters";

export default {
  components: {
    Filters,
  },

  data() {
    return {
      dl: this.$store.state.config.app.dl,
      magazines: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/magazines?include=issuesCount,latestIssue,category"
      ),
    };
  },

  created() {
    this.magazines.filter({ search: localStorage.getItem('magazine-search') || '' }).load();
  },
};
</script>
